import React from "react";
import {GraphQlSelect} from "./GraphQlSelect";
import { useBoroughQueryQuery} from "../../generated/graphql";
import {GraphQlSelectId} from "./GraphQlSelectId";

export const BoroughSelect = (props) => {
    const query = useBoroughQueryQuery();
    return props.valueIsId?<GraphQlSelectId queryResult={query} {...props}  labelField="label" />:<GraphQlSelect queryResult={query} {...props}  labelField="label" />;
}